import React from "react";
import "./footer.css";
import {
  Facebook,
  Instagram,
  Telegram,
  WhatsApp,
  LinkedIn,
} from "@mui/icons-material";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="first-column">
            <div className="footer-section catalog">
              <h6 className="small-title">
                <span className="dot red"></span>
                CATALOG
              </h6>
              <ul>
                <li className="large-links">
                  <a href="/">Find a Lawyer</a>
                </li>
                <li className="large-links">
                  <a href="/waitlist">Community</a>
                </li>
                <li className="large-links">
                  <a href="/grow/sign-up">Register your firm</a>
                </li>
                <li className="large-links">
                  <a href="/grow/attorney">For Lawyers</a>
                </li>
                <li className="large-links">
                  <a href="/contact-us">About</a>
                </li>
              </ul>
            </div>

            <div className="footer-section about">
              <h6 className="small-title">
                <span className="dot gray"></span> ABOUT US
              </h6>
              <ul>
                <li className="small-links">Our Mission</li>
                <li className="small-links">Careers</li>
              </ul>
            </div>
          </div>

          <div className="second-column">
            <div className="thick-line"></div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="inner-column">
                <div className="footer-section contact">
                  <h6 className="small-title">
                    <a href="/contact-us">
                      <span className="dot gray"></span> CONTACT US
                    </a>
                  </h6>
                  <ul>
                    <li className="small-links">
                      Email -{" "}
                      <a href="mailto:connect@quidpro.ai">connect@quidpro.ai</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-section legal">
                  <h6 className="small-title">
                    <span className="dot gray"></span> LEGAL
                  </h6>
                  <ul>
                    <li className="small-links">Privacy</li>
                    <li className="small-links">Terms of Service</li>
                    <li className="small-links">Disclaimer</li>
                  </ul>
                </div>
              </div>
              <div className="third-column">
                <div className="social-icons">
                  <a href="#" aria-label="Facebook" className="icon-button">
                    <Facebook />
                  </a>
                  <a
                    href="https://linkedin.com/company/quidproai"
                    aria-label="Linkedin"
                    className="icon-button"
                  >
                    <LinkedIn />
                  </a>
                  <a aria-label="Instagram" className="icon-button">
                    <Instagram />
                  </a>
                  <a href="#" aria-label="Telegram" className="icon-button">
                    <Telegram />
                  </a>
                  <a href="#" aria-label="WhatsApp" className="icon-button">
                    <WhatsApp />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; 2024 Quidpro.ai. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
